function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 73.168,
  height: 73.168,
  viewBox: "0 0 73.168 73.168",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.242 14.425h64.684c2.344 0 4.242-1.933 4.242-4.324 0-2.385-1.898-4.325-4.242-4.325H4.242C1.898 5.776 0 7.716 0 10.101c0 2.392 1.898 4.324 4.242 4.324m64.684 17.834H4.242C1.898 32.259 0 34.2 0 36.584c0 2.393 1.898 4.325 4.242 4.325h64.684c2.344 0 4.242-1.933 4.242-4.325 0-2.384-1.898-4.325-4.242-4.325m0 26.483H4.242C1.898 58.742 0 60.683 0 63.067c0 2.393 1.898 4.325 4.242 4.325h64.684c2.344 0 4.242-1.935 4.242-4.325 0-2.384-1.898-4.325-4.242-4.325"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-menu.svg";
export { SvgComponent as ReactComponent };